/* Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. */

import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { takeUntil } from 'rxjs/operators';
import { GenericDialogComponent } from 'src/app/common/generic-dialog/generic-dialog.component';
import { GenericDialogData } from 'src/app/modules/projects2/projects2.interfaces';
import * as appStrings from '@touchplan/strings';

interface ISecretDialogData extends GenericDialogData {
	clientId: string;
	password: string;
}

@Component({
	selector: 'app-secret-dialog',
	templateUrl: './app-secret-dialog.component.html',
	styleUrls: ['./app-secret-dialog.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
/**
 * Material dialog that presents the Client ID and (generated) Client Secret for an organization's application.
 */
export class AppSecretDialog extends GenericDialogComponent {
	public passwordInputType = 'password';

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: ISecretDialogData,
		public dialogRef: MatDialogRef<AppSecretDialog>,
		protected formBuilder: UntypedFormBuilder
	) {
		super(data, dialogRef, formBuilder);
	}

	public static open(
		applicationName: string,
		clientId: string,
		password: string,
		dialog: MatDialog,
		shutdownSubject$
	): void {
		const data = {
			title: appStrings.ORG_CRED_DIALOG_TITLE,
			content: appStrings.ORG_CRED_DIALOG_LINES(applicationName),
			clientId,
			password,
			noButtonText: appStrings.UICONTROL_TEXT_CLOSE.toUpperCase(),
		} as ISecretDialogData;

		dialog
			.open(AppSecretDialog, { data, disableClose: true })
			.afterClosed()
			.pipe(takeUntil(shutdownSubject$));
	}

	public togglePasswordVisibility() {
		if (this.passwordInputType === 'password') {
			this.passwordInputType = 'text';
		} else {
			this.passwordInputType = 'password';
		}
	}
}
